import { render, staticRenderFns } from "./StockUserSelector.vue?vue&type=template&id=bc5e7294&scoped=true&"
import script from "./StockUserSelector.vue?vue&type=script&lang=ts&"
export * from "./StockUserSelector.vue?vue&type=script&lang=ts&"
import style0 from "./StockUserSelector.vue?vue&type=style&index=0&id=bc5e7294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5e7294",
  null
  
)

export default component.exports